export default {
  'site.name': '爱情岛视频',
  'site.slogan': '高清在线观看入口',
  'site.description': '提供最新爱情岛视频资源，支持免费流畅观看',
  'nav.home': '首页',
  'nav.category': '分类',
  'nav.about': '关于我们',
  'nav.search': '搜索视频...',
  'footer.copyright': '© 2026 爱情岛视频 版权所有',
  'footer.disclaimer': '本站所有视频资源均来自互联网，仅供交流学习之用',
  'footer.privacy': '隐私政策',
  'footer.terms': '使用条款',
  'breadcrumb.home': '首页',
  'breadcrumb.category': '分类',
  'breadcrumb.article': '文章详情',
  'breadcrumb.about': '关于我们',
  'button.watch': '立即观看',
  'button.viewAll': '查看全部',
  'button.loadMore': '加载更多',
  'label.views': '次观看',
  'label.duration': '时长',
  'label.rating': '评分',
  'label.date': '日期',
  'label.category': '分类',
  'label.tags': '标签',
  'label.related': '相关推荐',
  'label.noResults': '暂无相关内容',
};